export const terminalThemes = {
  'Default Dark': {
    background: '#000000',
    text: '#ffffff',
    accent: '#00ff9d',
    correct: '#00ff9d',
    incorrect: '#ff3d3d',
    header: '#0a0a0a',
    border: '#1a1a1a'
  },
  'Default Light': {
    background: '#f0f0f0',
    text: '#000000',
    accent: '#0099ff',
    correct: '#0099ff',
    incorrect: '#ff0000',
    header: '#e0e0e0',
    border: '#d0d0d0'
  },
  'Matrix': {
    background: '#000000',
    text: '#00ff00',
    accent: '#00ff00',
    correct: '#00ff00',
    incorrect: '#ff0000',
    header: '#001100',
    border: '#003300'
  },
  'Cyberpunk': {
    background: '#1a1a2e',
    text: '#e94560',
    accent: '#e94560',
    correct: '#00ff00',
    incorrect: '#ff0000',
    header: '#16213e',
    border: '#0f3460'
  },
  'Retro': {
    background: '#2b2b2b',
    text: '#33ff33',
    accent: '#ff33ff',
    correct: '#33ff33',
    incorrect: '#ff3333',
    header: '#1a1a1a',
    border: '#404040'
  },
  'Ocean': {
    background: '#0a192f',
    text: '#64ffda',
    accent: '#64ffda',
    correct: '#64ffda',
    incorrect: '#ff6b6b',
    header: '#112240',
    border: '#1d3461'
  },
  'Solarized Dark': {
    background: '#002b36',
    text: '#93a1a1',
    accent: '#268bd2',
    correct: '#859900',
    incorrect: '#dc322f',
    header: '#073642',
    border: '#586e75'
  },
  'Solarized Light': {
    background: '#fdf6e3',
    text: '#657b83',
    accent: '#268bd2',
    correct: '#859900',
    incorrect: '#dc322f',
    header: '#eee8d5',
    border: '#93a1a1'
  },
  'Nord': {
    background: '#2e3440',
    text: '#eceff4',
    accent: '#88c0d0',
    correct: '#a3be8c',
    incorrect: '#bf616a',
    header: '#3b4252',
    border: '#4c566a'
  },
  'Dracula': {
    background: '#282a36',
    text: '#f8f8f2',
    accent: '#bd93f9',
    correct: '#50fa7b',
    incorrect: '#ff5555',
    header: '#44475a',
    border: '#6272a4'
  },
  'Monokai': {
    background: '#272822',
    text: '#f8f8f2',
    accent: '#a6e22e',
    correct: '#a6e22e',
    incorrect: '#f92672',
    header: '#3e3d32',
    border: '#75715e'
  },
  'GitHub Light': {
    background: '#ffffff',
    text: '#24292e',
    accent: '#0366d6',
    correct: '#22863a',
    incorrect: '#cb2431',
    header: '#f6f8fa',
    border: '#e1e4e8'
  },
  'GitHub Dark': {
    background: '#0d1117',
    text: '#c9d1d9',
    accent: '#58a6ff',
    correct: '#238636',
    incorrect: '#da3633',
    header: '#161b22',
    border: '#30363d'
  }
}; 